import { render, staticRenderFns } from "./bodyViewer.vue?vue&type=template&id=7bf7ba3c"
import script from "./bodyViewer.vue?vue&type=script&lang=ts"
export * from "./bodyViewer.vue?vue&type=script&lang=ts"
import style0 from "./bodyViewer.vue?vue&type=style&index=0&id=7bf7ba3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports